<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-img src="../assets/img/TBetMake_Logo-RGB-Hori-noTAG.png" position="left" contain height="50"></v-img>
        Enrol New Terminal
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col md="6">
            <v-text-field dense hide-details outlined label="Terminal Hash" disabled v-model="terminalHash"></v-text-field>
          </v-col>
          <v-col md="6">
            <v-text-field dense @focus="handleBranchFocus" outlined label="Terminal Branch Name **IF APPLICABLE**" counter="45" :rules="rules" persistent-hint hint="Branch Name eg: BettingShop1" v-model="terminalBranch"></v-text-field>
          </v-col>
        </v-row>
        <v-text-field class="mt-4" @focus="handleTechnicianFocus" dense label="Technician's Name" outlined persistent-hint  :name="Math.random()" hint="Name of person installing new terminal" v-model="technicianName"></v-text-field>
        <v-text-field class="mt-2" dense @focus="handleLocationFocus" outlined counter="45" :rules="rules" label="Terminal Location ID" persistent-hint hint="Description of the terminal location eg: SouthCafe_Terminal001" v-model="terminalLocation"></v-text-field>
        <v-text-field class="mt-2" dense @focus="handleVenueFocus" outlined label="Venue" persistent-hint hint="This describes the venue eg. Monmouth" v-model="venueName"></v-text-field>
        <h5 v-if="error">Error: {{error}}</h5>
      </v-card-text>
        <v-row v-if="enrolling"
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            Enrolling Terminal, please wait...
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="pink accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      <v-card-actions class="py-8" v-else>
        <v-btn elevation="0" color="success" style="position: absolute; right: 25px;" @click="manageEnrolTerminal">Enrol</v-btn>
        <v-btn elevation="0" color="error" style="position: absolute; right: 100px;" @click="terminalFailClose">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <div>
      <SimpleKeyboard @onChange="onChange" @onKeyPress="onKeyPress" :input="input"/>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import axios from "axios"
import SimpleKeyboard from '../components/SimpleKeyboard'

export default {
  name: 'EnrolTerminal',
  data () {
    return {
      terminalHash: this.$route.params.terminalHash,
      venueName: '',
      terminalLocation: '',
      terminalBranch: '',
      technicianName: '',
      error: '',
      interval: null,
      validated: false,
      enrolling: false,
      rules: [v => v.length <= 45 || 'Max 45 characters'],
      selectedInput: null
    }
  },
  components: {
    SimpleKeyboard
  },
  computed: {
    input: {
      get () { 
        if (this.selectedInput === 'technicianName') {
          return this.selectedInput === 'technicianName' ? this.technicianName : this.venueName
        }
        if (this.selectedInput === 'terminalLocation') {
          return this.selectedInput === 'terminalLocation' ? this.terminalLocation : this.venueName
        }
        if (this.selectedInput === 'terminalBranch') {
          return this.selectedInput === 'terminalBranch' ? this.terminalBranch : this.venueName
        }
        if (this.selectedInput === 'venueName') {
          return this.selectedInput === 'venueName' ? this.venueName : this.venueName
        }
        return null
      },
      set () {
      }
    }
  },
  methods: {
    ...mapActions(['enrolTerminal','signOut','setTerminalFail', 'setTerminalFailMsg']),
    manageEnrolTerminal () {
      this.enrolTerminal({ terminalId: this.terminalHash, venueName: this.venueName, terminalLocation: this.terminalLocation, technicianName: this.technicianName })
    },
    handleTechnicianFocus() {
      this.selectedInput = 'technicianName'
    },
    handleBranchFocus() {
      this.selectedInput = 'terminalBranch'
    },
    handleLocationFocus() {
      this.selectedInput = 'terminalLocation'
    },
    handleVenueFocus() {
      this.selectedInput = 'venueName'
    },
    onChange(input) {
      if (this.selectedInput === 'technicianName') {
        this.technicianName = input
      }
      if (this.selectedInput === 'terminalLocation') {
        this.terminalLocation = input
      }
      if (this.selectedInput === 'terminalBranch') {
        this.terminalBranch = input
      }
      if (this.selectedInput === 'venueName') {
        this.venueName = input
      }
    },
    onKeyPress() {
    },
    terminalFailClose () {
      this.signOut()
      this.setTerminalFail(false)
      this.setTerminalFailMsg(null)
      this.signedIn = false
      this.$router.go(-1)
    },
    async enrolTerminal () {
      await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/EnrolTerminal`, {
        terminal_id: this.terminalHash,
        venue_name: this.venueName,
        terminal_branch: this.terminalBranch,
        terminal_location: this.terminalLocation,
        technician_name: this.technicianName
      },{
        withCredentials:false
      })
      .then(() => {
        this.enrolling = true
        setTimeout(() => { this.validateTerminal() }, 10000)
      })
      .catch ((err) => {
        this.error = err
      })
    },
    async validateTerminal () {
      await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/ValidateTerminal`, {
        ba_terminalid: this.terminalHash
      },{
        withCredentials:false
      })
      .then((res) => {
        this.validated = true
        this.interval = null
        this.enrolling = false
        console.log(`${process.env.VUE_APP_WRAPPER_URL}?venue=${res.data.venue}&id=${this.terminalHash}`)
        // if there is enrollment bridge initialized, send a restart message to the main process
        if(window.enrollment){
          window.enrollment.restartApp()
        }
        else{
          // to handle the terminals using the old wrapper, just reload the register page to login page
          window.location.replace(`${process.env.VUE_APP_WRAPPER_URL}?venue=${res.data.venue}&id=${this.terminalHash}`)
        }
      })
      .catch (() => {
        setTimeout(() => {
          if (!this.validated) this.validateTerminal()
        }, 10000)
      })
    }
  }
}
</script>
